import ls from '@/utils/Storage'
import { ACCESS_TOKEN, PERMISSION, USER_INFO, MENU_NAV } from '@/store/mutation-types'
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'
import axios from 'axios'; // 新增：导入axios用于全局配置
// import os from 'os'

dayjs.extend(utc)
dayjs.extend(timezone)

export function clearUserInfo() {
  ls.remove(ACCESS_TOKEN)
  ls.remove(PERMISSION)
  ls.remove(USER_INFO)
  ls.remove(MENU_NAV)
}

export function timeFix() {
  const time = new Date()
  const hour = time.getHours()
  return hour < 9 ? '早上好' : hour <= 11 ? '上午好' : hour <= 13 ? '中午好' : hour < 20 ? '下午好' : '晚上好'
}

// aes encryption key
export const encryptKeys = {
  // key最少4位,否则报错
  key: '1111',
  iv: '1',
};

export const getQueryParameters = (options) => {
  const url = options.url
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse('{"' + decodeURIComponent(search)
    .replace(/"/g, '\\"')
    .replace(/&/g, '","')
    .replace(/=/g, '":"') + '"}')
}

export const getBody = (options) => {
  return options.body && JSON.parse(options.body)
}

/**
 * 评估密码强度并返回评分
 * @param pass 要评估的密码字符串
 * @returns 密码强度的整数评分（分数越高表示密码强度越高）
 */
export function scorePassword(pass) {
  let score = 0
  if (!pass) {
    return score
  }
  // award every unique letter until 5 repetitions
  const letters = {}
  for (let i = 0; i < pass.length; i++) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1
    score += 5.0 / letters[pass[i]]
  }

  // bonus points for mixing it up
  const variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  }

  let variationCount = 0
  for (var check in variations) {
    variationCount += (variations[check] === true) ? 1 : 0
  }
  score += (variationCount - 1) * 10

  return parseInt(score)
}

export const firstLetterIsUpperCase = function (str) {
  var reg = /^[A-Z][A-z0-9]*$/;
  return reg.test(str);
};

export const separator = ';'

export const divisionStringToArray = (string, customSeparator) => {
  return string ? string.split(customSeparator || separator) : []
}

export const getWeek = (week: number, useZhou) => {
  let txt = ''
  switch (week) {
    case 1:
      txt = '一'
      break
    case 2:
      txt = '二'
      break
    case 3:
      txt = '三'
      break
    case 4:
      txt = '四'
      break
    case 5:
      txt = '五'
      break
    case 6:
      txt = '六'
      break
    case 0:
      txt = '日'
      break
    default:
      return 'getWeekError'
  }
  return useZhou ? '周' : '星期' + txt
}

const sitUrl = 'xxxxx'
export const isDev = import.meta.env.DEV
const currentMode = import.meta.env.MODE;

// ========== 核心：动态IP配置逻辑（仅这一段是新增） ==========
// 全局缓存配置（对齐你指定的JSON格式）
let apiConfig: {
  baseURLMap: Record<string, string>;
  defaultBaseURL: string;
} | null = null;

// 兜底默认配置（和你指定的JSON格式一致）
const defaultApiConfig = {
  baseURLMap: {
    development: 'http://127.0.0.1:8080',
    localhost: '/',
    production: 'http://110.41.51.219:8090'
  },
  defaultBaseURL: 'http://110.41.51.219:8080'
};

// 1. 先设置同步兜底baseURL（防止首次请求报错）
axios.defaults.baseURL = defaultApiConfig.baseURLMap[currentMode] || defaultApiConfig.defaultBaseURL;

// 2. 异步加载最新配置（读取public/api-config.json）
const loadApiConfig = async () => {
  if (apiConfig) return;
  try {
    const res = await fetch('/api-config.json');
    if (res.ok) {
      apiConfig = await res.json();
      // 更新为JSON文件中的最新配置
      // axios.defaults.baseURL = apiConfig.baseURLMap[currentMode] || apiConfig.defaultBaseURL;
      axios.defaults.baseURL = apiConfig?.baseURLMap?.[currentMode] || defaultApiConfig.baseURLMap[currentMode] || defaultApiConfig.defaultBaseURL;
      console.log('✅ 接口地址已更新为:', axios.defaults.baseURL);
    }
  } catch (err) {
    console.warn('⚠️ 配置文件加载失败，使用默认地址:', err);
  }
};

// 页面初始化时加载配置
loadApiConfig();

// 对外暴露获取地址的方法（可选）
export const getBaseURL = () => axios.defaults.baseURL;
export const baseURL = axios.defaults.baseURL;
// ========== 动态IP配置逻辑结束 ==========

// 打印环境信息（用于调试）
console.log('当前环境是否为开发环境: ', isDev)
console.log('当前接口地址:', baseURL)
console.log('当前环境模式:', currentMode)

export function toLocalTimeStr({ date, format = 'YYYY-MM-DD HH:mm:ss' }) {
  if (!date) return null;
  return dayjs(date).format(format)
}

export function objToArr(obj) {
  let arr: any = []
  for (const o in obj) {
    arr.push({ label: o, txt: obj[o] })
  }
  return arr
}

export function clearObj(obj) {
  for (const key in obj) {
    obj[key] = undefined
  }
}

export function delArrItem(arr, item) {
  const index = arr.indexOf(item);
  arr.splice(index, 1);
}

export const useImageUrl = (name: string, type: string = 'png'): string => {
  return new URL(`../assets/images/${name}.${type}`, import.meta.url).href
}

export const batchDispatch = (dispatch, arr) => {
  arr.forEach(item => {
    dispatch(item)
  });
}

export const createFormData = (formDatas, file) => {
  const formData = new FormData()
  if (file.length) {
    file.map(item => {
      formData.append('file', item)
    })
  } else {
    formData.append('file', file)
  }
  for (const item in formDatas) {
    formData.append(item, formDatas[item] || '')
  }
  return formData
}

// 获取两个对象之间的差异不同
export function deepDiffKeys(obj1, obj2) {
  const diffKeys = []

  function deepCompare(o1, o2, key) {
    if (o1 === o2) return
    if (typeof o1 !== 'object' || o1 === null || typeof o2 !== 'object' || o2 === null) {
      diffKeys.push(key)
      return
    }

    for (const k in o1) {
      if (o2[k] === undefined) {
        diffKeys.push(key + '.' + k)
      } else {
        deepCompare(o1[k], o2[k], key + '.' + k)
      }
    }

    for (const k in o2) {
      if (o1[k] === undefined) {
        diffKeys.push(key + '.' + k)
      }
    }
  }

  deepCompare(obj1, obj2, 'root')
  return diffKeys
}

/**
 * 获取本机的 IPv4 地址（非 127.0.0.1）
 * 浏览器环境返回空字符串，Node.js 环境正常获取
 * @returns {string} - 本机的 IP 地址
 */
export async function getServerIp(): Promise<string> {
  if (typeof window !== 'undefined') {
    console.warn('浏览器环境不支持获取本机IP');
    return "";
  }

  try {
    const os = await import('os');
    const interfaces = os.networkInterfaces();

    for (const ifaceName in interfaces) {
      const iface = interfaces[ifaceName];
      if (!iface) continue;

      for (const alias of iface) {
        if (alias.family === 'IPv4' && alias.address !== '127.0.0.1' && !alias.internal) {
          return alias.address;
        }
      }
    }
    return "";
  } catch (error) {
    console.error('获取本机IP失败:', error);
    return "";
  }
}

/**
 * 获取本机主机名
 * 浏览器环境返回空字符串，Node.js 环境正常获取
 * @returns {string} - 本机主机名
 */
export async function getHostname(): Promise<string> {
  if (typeof window !== 'undefined') {
    console.warn('浏览器环境不支持获取主机名');
    return "";
  }

  try {
    const os = await import('os');
    const hostname = os.hostname();
    return typeof hostname === 'string' ? hostname : '';
  } catch (error) {
    console.error('获取主机名失败:', error);
    return '';
  }
}